import Icon from "common/components/icons";
import styled, { css } from "styled-components";

export const Container = styled.div`
  background: ${(props) => props.theme.splash.bg};
  box-sizing: border-box;
  height: 100%;
  height: 100dvh;
  max-height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  direction: ltr;
  padding: 24px 20px calc(24px + env(safe-area-inset-bottom));
  overflow-x: hidden;

  @media screen and (max-width: 700px) {
    padding: 18px 16px calc(18px + env(safe-area-inset-bottom));
  }
`;

export const StaticHeader = styled.div`
  width: min(100%, 560px);
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  padding-top: 12px;

  @media screen and (max-width: 700px) {
    padding-top: 4px;
  }
`;

export const IntroScrollArea = styled.div`
  width: min(100%, 560px);
  flex: 0 1 auto;
  min-height: 0;
  max-height: min(48dvh, 420px);
  overflow: visible;
  margin-top: 12px;
  padding-bottom: 8px;

  @media screen and (max-width: 700px) {
    max-height: min(52dvh, 430px);
    margin-top: 16px;
  }
`;

export const LogoWrapper = styled.div`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: -100px;
    bottom: 0;
    top: 0;
    width: 100px;
    background: ${(props) => props.theme.splash.gradient}
    animation: glisten 2s ease-in 0.8s infinite;
  }

  @keyframes glisten {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(150px);
    }
  }
`;

export const Logo = styled(Icon)`
  z-index: 3;
  fill: ${(props) => props.theme.splash.logoFill};
  width: 60px;
  height: 60px;

  @media screen and (max-width: 700px) {
    width: 52px;
    height: 52px;
  }
`;

export const Progress = styled.div<{ progess: number }>`
  width: min(90%, 400px);
  height: 4px;
  margin: 20px auto 16px;
  background: ${(props) => props.theme.splash.progressBg};
  position: relative;
  direction: ltr;
  border-radius: 999px;
  overflow: hidden;

  @media screen and (max-width: 700px) {
    height: 6px;
    margin: 14px auto 12px;
    width: min(88vw, 340px);
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    /* background: rgb(0, 216.5, 187.0288); */
    background: ${(props) => props.theme.splash.progressAfterBg};
    transition: ${(props) =>
      props.progess >= 100 ? "width 0ms linear" : "width 260ms linear"};

    ${(props) => css`
      width: ${props.progess}%;
    `};
  }
`;

export const Title = styled.h1`
  color: ${(props) => props.theme.splash.titleColor};
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 8px;

  @media screen and (max-width: 700px) {
    margin-bottom: 4px;
  }
`;

export const SubTitle = styled.p`
  color: ${(props) => props.theme.splash.subTitleColor};
  font-size: 0.85rem;
  margin-bottom: 18px;
  text-align: center;

  @media screen and (max-width: 700px) {
    font-size: 0.8rem;
    margin-bottom: 14px;
  }
`;

export const EncryptionIcon = styled(Icon)`
  color: ${(props) => props.theme.splash.iconColor};
`;

export const IntroCard = styled.section`
  width: min(100%, 560px);
  background: ${(props) => props.theme.common.secondaryColor};
  border-radius: 18px;
  overflow: hidden;
  direction: rtl;
  text-align: right;
  margin: 0 auto;
`;

export const IntroCardBody = styled.div`
  max-height: min(48dvh, 420px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px;
  -webkit-overflow-scrolling: touch;

  @media screen and (max-width: 700px) {
    max-height: min(52dvh, 430px);
    padding: 18px 16px;
  }
`;

export const ProjectTitle = styled.h2`
  color: ${(props) => props.theme.common.mainHeadingColor};
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0 0 12px;
`;

export const IntroText = styled.p`
  color: ${(props) => props.theme.common.subHeadingColor};
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0 0 12px;
`;

export const ContinueButton = styled.button`
  margin-top: 8px;
  width: 100%;
  border: 0;
  border-radius: 999px;
  padding: 13px 18px;
  font-size: 0.95rem;
  font-weight: 600;
  background: ${(props) => props.theme.common.tertiaryColor};
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;

  &:hover:not(:disabled) {
    opacity: 0.92;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
  }
`;

export const Link = styled.a`
  text-decoration: revert-layer;

  &:hover {
    text-decoration: revert-layer;
  }
`;
